import React, { useState } from 'react';
import {
    Box,
    Container,
    Typography,
    Stack,
    Chip,
    Grid,
    Card,
    CardMedia,
} from '@mui/material';
import HeroButton from './HeroButton';
import PlayIcon from '@mui/icons-material/PlayCircleOutline';

function Hero({ course }) {
    const [showVideo, setShowVideo] = useState(false);

    return (
        <Box sx={{ backgroundColor: '#f9f9f9', py: 6 }}>
            <Container>
                <Grid container spacing={4}>
                    {/* Left Section */}
                    <Grid item xs={12} md={6}>
                        <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
                            <Chip label={course.level} color='primary' variant="outlined" />
                            <Chip label={course.domain} color='primary' variant="outlined" />
                        </Stack>

                        <Typography
                            variant="h4"
                            sx={{
                                fontWeight: 700,
                                fontSize: { xs: '2rem', sm: '2.5rem' },
                                color: '#333',
                                mb: 2,
                            }}
                        >
                            {course.title}
                        </Typography>

                        <Typography
                            variant="body2"
                            sx={{
                                fontSize: '0.9rem',
                                color: '#555',
                                maxWidth: '700px',
                                mb: 3,
                                lineHeight: 1.6,
                            }}
                        >
                            {course.description}
                        </Typography>

                        <HeroButton course={course} />

                        {/* <Box>
                            <Box
                                component="button"
                                onClick={() => alert('Start Learning button clicked!')}
                                sx={{
                                    display: 'block',
                                    backgroundColor: 'primary.main',
                                    color: '#fff',
                                    textTransform: 'none',
                                    fontSize: '1.1rem',
                                    fontWeight: '500',
                                    border: 'none',
                                    borderRadius: 8,
                                    padding: '16px 48px',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.3s',
                                    '&:hover': {
                                        backgroundColor: 'primary.dark',
                                    },
                                }}
                            >
                                Start Learning
                            </Box>
                        </Box> */}

                    </Grid>

                    {/* Right Section */}
                    <Grid item xs={12} md={6}>
                        <Card
                            sx={{
                                boxShadow: 'none',
                                borderRadius: '12px',
                                overflow: 'hidden',
                                position: 'relative',
                                cursor: 'pointer',
                            }}
                            onClick={() => setShowVideo(true)}
                        >
                            {!showVideo ? (
                                <>
                                    <CardMedia
                                        component="img"
                                        image={course.thumbnail}
                                        alt="Course Thumbnail"
                                        sx={{
                                            width: '100%',
                                            aspectRatio: '16 / 9', // Maintain 16:9 ratio
                                            objectFit: 'cover',
                                            padding: 0,
                                            margin: 0,
                                            display: 'block',
                                        }}
                                    />
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                            borderRadius: '50%',
                                            pt: '8px',
                                            pb: '4px',
                                            px: '8px',
                                        }}
                                    >
                                        <PlayIcon
                                            sx={{
                                                fontSize: '3rem',
                                                color: '#fff',
                                            }}
                                        />
                                    </Box>
                                </>
                            ) : (
                                <iframe
                                    src={course.previewVideo}
                                    title={course.title}
                                    style={{
                                        width: '100%',
                                        aspectRatio: '16 / 9', // Maintain 16:9 ratio
                                        border: 'none',
                                        borderRadius: '12px',
                                        display: 'block',
                                    }}
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    referrerPolicy="strict-origin-when-cross-origin"
                                />
                            )}
                        </Card>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}

export default Hero;
